import Navbar from './navbar.vue';
export default Navbar;


// WEBPACK FOOTER //
// ./src/components/navbar/index.js